(function () {
  var REVIEW_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-review';
  var REVIEW_TITLE = 'Review your selections';
  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');
  var enhancing = false;
  var enhanceTimer = null;
  var observerTimer = null;
  var lastReviewFingerprint = '';

  function getConfigTitle() {
    var config = window.ciwLaStepTitles || {};
    return config.review || REVIEW_TITLE;
  }

  function isEyeglassFlow() {
    if (!window.ciwLaHostApi) return !!document.querySelector('.ciw-pdp');
    return window.ciwLaHostApi.isActive() && !window.ciwLaHostApi.isContactLens();
  }

  function normalizeText(value) {
    if (value && typeof value === 'object' && value.nodeType === 1) {
      value = value.textContent;
    }
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatMoneyFromAmount(amount) {
    var cents = Math.round(parseFloat(amount || 0) * 100);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.theme && window.Shopify.theme.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function extractPriceText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    var compare = clone.querySelector('.la-compare-at-price');
    if (compare) compare.remove();
    var match = normalizeText(clone.textContent).match(/\$[\d,]+(?:\.\d{2})?/);
    return match ? match[0] : normalizeText(clone.textContent);
  }

  function extractComparePriceText(el) {
    if (!el) return '';

    var roots = [];
    if (el.closest) {
      var reviewRight = el.closest('.la-review-right');
      if (reviewRight) roots.push(reviewRight);
      var reviewItem = el.closest('.la-review-item');
      if (reviewItem) roots.push(reviewItem);
    }
    roots.push(el);

    var i;
    for (i = 0; i < roots.length; i++) {
      var compare = roots[i].querySelector('.la-compare-at-price');
      if (!compare) continue;
      var match = normalizeText(compare.textContent).match(/\$[\d,]+(?:\.\d{2})?/);
      return match ? match[0] : normalizeText(compare.textContent);
    }

    return '';
  }

  function getFrameFirst30Prices() {
    var config = window.ciwLaSubtotalFooter || {};
    var enabled = config.first30 === true || config.first30 === 'true';
    if (!enabled) return null;

    var listAmount = parseFloat(config.first30FrameList);
    var saleAmount = parseFloat(config.first30FrameSale);
    if (isNaN(listAmount) || isNaN(saleAmount) || listAmount <= 0 || saleAmount <= 0) {
      return null;
    }
    if (listAmount <= saleAmount) return null;

    return {
      list: formatMoneyFromAmount(listAmount),
      sale: formatMoneyFromAmount(saleAmount),
      listAmount: listAmount,
      saleAmount: saleAmount
    };
  }

  function getFirst30ListAmountFromVariantJson() {
    var variantIdInput =
      document.querySelector('.ciw-pdp form input[name="id"]') ||
      document.querySelector('product-form input[name="id"]');
    if (!variantIdInput) return 0;

    var jsonEl = document.querySelector('script[type="application/json"][id^="ProductJSON-"]');
    if (!jsonEl) return 0;

    try {
      var variants = JSON.parse(jsonEl.textContent);
      var variantId = String(variantIdInput.value || '');
      var variant = null;
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === variantId) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) return 0;

      var priceCents = parseFloat(variant.price);
      var compareCents = parseFloat(variant.compare_at_price);
      if (isNaN(priceCents) || priceCents <= 0) return 0;

      var listCents = priceCents;
      if (!isNaN(compareCents) && compareCents > priceCents) {
        var ratio = Math.round((priceCents * 100) / compareCents);
        if (ratio >= 68 && ratio <= 72) {
          listCents = compareCents;
        }
      }

      return listCents / 100;
    } catch (error) {
      return 0;
    }
  }

  function getFrameCompareFromLensAdvizor(saleAmount) {
    var la = window.LensAdvizor;
    if (!la) return '';

    var prices = la.prices || {};
    var compareKeys = ['frameCompare', 'frame_compare', 'compareFrame', 'compare_at_frame'];
    var i;
    for (i = 0; i < compareKeys.length; i++) {
      var compareVal = parseFloat(prices[compareKeys[i]]);
      if (!isNaN(compareVal) && compareVal > 0 && (!saleAmount || compareVal > saleAmount)) {
        return formatMoneyFromAmount(compareVal);
      }
    }

    var variantId = la.selectedOrDefaultVariant;
    if (variantId && la.variants && la.variants[variantId]) {
      var variant = la.variants[variantId];
      var variantCompare = parseFloat(variant.compare_at_price);
      var variantPrice = parseFloat(variant.price);
      if (!isNaN(variantCompare) && variantCompare > 0) {
        if (
          !isNaN(variantPrice) &&
          variantPrice > 200 &&
          variantCompare > 200
        ) {
          variantCompare = variantCompare / 100;
        }
        if (!saleAmount || variantCompare > saleAmount) {
          return formatMoneyFromAmount(variantCompare);
        }
      }
    }

    return '';
  }

  function getShopifyVariantComparePrice(saleAmount) {
    var variantIdInput =
      document.querySelector('.ciw-pdp form input[name="id"]') ||
      document.querySelector('product-form input[name="id"]');
    if (!variantIdInput) return '';

    var jsonEl = document.querySelector('script[type="application/json"][id^="ProductJSON-"]');
    if (!jsonEl) return '';

    try {
      var variants = JSON.parse(jsonEl.textContent);
      var variantId = String(variantIdInput.value || '');
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === variantId) {
          variant = variants[i];
          break;
        }
      }
      if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
        return '';
      }
      var compareAmount = variant.compare_at_price / 100;
      if (saleAmount && compareAmount <= saleAmount) return '';
      return formatMoneyFromAmount(compareAmount);
    } catch (error) {
      return '';
    }
  }

  function parsePriceNumber(text) {
    if (!text) return 0;
    var match = String(text).replace(/,/g, '').match(/\$?([\d.]+)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function formatMethodLabel(methodText) {
    var text = normalizeText(methodText);
    if (/email later/i.test(text)) return 'Send prescription later';
    if (/upload file/i.test(text)) return 'Upload prescription';
    if (/enter manually/i.test(text)) return 'Enter manually';
    if (/prescription on file/i.test(text)) return 'Use prescription on file';
    return text;
  }

  function htmlToPlainText(html) {
    return normalizeText(
      String(html || '')
        .replace(/<br\s*\/?>/gi, ', ')
        .replace(/<\/div>/gi, ', ')
        .replace(/<[^>]+>/g, ' ')
    )
      .replace(/,\s*,/g, ',')
      .replace(/,\s*$/g, '');
  }

  function setReviewTitle(step) {
    if (!step) return;
    var titleEl =
      step.querySelector('#la_prescriptionSelect_title') ||
      step.querySelector('.la-wrapper-heading h3');
    if (!titleEl) return;
    var title = getConfigTitle();
    if (titleEl.textContent.trim() === title) return;
    titleEl.textContent = title;
  }

  function getFeaturedImageSrc() {
    var img =
      document.querySelector('#la-product-featured-image') ||
      document.querySelector('.la-prescription-modal-image img');
    return img && img.getAttribute('src') ? img.getAttribute('src') : '';
  }

  var FRAME_SIZE_WORDS = /^(xs|s|small|medium|large|xl|xxl|extra\s*wide|narrow|average|wide)$/i;

  function isFrameSizeLikeText(text) {
    var value = normalizeText(text);
    if (!value) return false;
    if (/^\d+(?:\.\d+)?\s*mm$/i.test(value)) return true;
    if (/^\d+(?:\.\d+)?\s*-\s*\d+/.test(value)) return true;
    return FRAME_SIZE_WORDS.test(value);
  }

  function formatFrameWidthMm(raw) {
    if (raw == null || raw === '' || raw === '--') return '';
    var text = normalizeText(String(raw)).replace(/,/g, '');
    var mmMatch = text.match(/^(\d+(?:\.\d+)?)\s*mm$/i);
    if (mmMatch) return mmMatch[1] + 'mm';
    var numMatch = text.match(/^(\d+(?:\.\d+)?)/);
    return numMatch ? numMatch[1] + 'mm' : '';
  }

  function extractMmFromSizeText(text) {
    if (!text) return '';
    var value = normalizeText(text);
    var mmMatch = value.match(/(\d+(?:\.\d+)?)\s*mm/i);
    if (mmMatch) return mmMatch[1] + 'mm';
    var dashMatch = value.match(/\b(\d+(?:\.\d+)?)\s*-\s*\d+/);
    if (dashMatch) return dashMatch[1] + 'mm';
    return formatFrameWidthMm(value);
  }

  function getSelectedVariantId() {
    var la = window.LensAdvizor;
    if (la && la.selectedOrDefaultVariant) return String(la.selectedOrDefaultVariant);

    var input =
      document.querySelector('.ciw-pdp form input[name="id"]') ||
      document.querySelector('product-form input[name="id"]');
    if (input && input.value) return String(input.value);

    var productInfo = document.querySelector('product-info.ciw-pdp');
    if (productInfo && typeof productInfo.resolveSelectedVariant === 'function') {
      var variant = productInfo.resolveSelectedVariant();
      if (variant && variant.id) return String(variant.id);
    }

    return '';
  }

  function getFrameWidthMmFromDom() {
    var widthInput =
      document.querySelector('.ciw-pdp [name="properties[_width]"]') ||
      document.querySelector('[name="properties[_width]"]');
    if (widthInput && widthInput.value) {
      var fromPrivate = formatFrameWidthMm(widthInput.value);
      if (fromPrivate) return fromPrivate;
    }

    var publicWidthInput =
      document.querySelector('.ciw-pdp [name="properties[Frame Width]"]') ||
      document.querySelector('[name="properties[Frame Width]"]');
    if (publicWidthInput && publicWidthInput.value) {
      var fromPublic = extractMmFromSizeText(publicWidthInput.value);
      if (fromPublic) return fromPublic;
    }

    var checkedSize = document.querySelector(
      '.ciw-pdp__variant-fieldset--frame-size input[type="radio"]:checked'
    );
    if (checkedSize) {
      var sizeLabel =
        checkedSize.closest('label') ||
        document.querySelector('label[for="' + checkedSize.id + '"]');
      if (sizeLabel) {
        var dataSpan = sizeLabel.querySelector('[data-lens]');
        if (dataSpan) {
          var fromLens = formatFrameWidthMm(dataSpan.getAttribute('data-lens'));
          if (fromLens) return fromLens;
        }

        var sizeValueEl = sizeLabel.querySelector('.ciw-pdp__frame-size-value');
        if (sizeValueEl) {
          var visibleText = normalizeText(sizeValueEl.childNodes[0] && sizeValueEl.childNodes[0].textContent);
          var fromVisible = extractMmFromSizeText(visibleText);
          if (fromVisible) return fromVisible;

          var tooltip = sizeValueEl.querySelector('.ciw-pdp__size-tooltip');
          if (tooltip) {
            var fromTooltip = extractMmFromSizeText(tooltip.textContent);
            if (fromTooltip) return fromTooltip;
          }
        }
      }
    }

    var selectedFitPill = document.querySelector('.ciw-pdp__size-pill--selected');
    if (selectedFitPill) {
      var fitTooltip = selectedFitPill.querySelector('.ciw-pdp__size-tooltip');
      if (fitTooltip) {
        var fromFitTooltip = extractMmFromSizeText(fitTooltip.textContent);
        if (fromFitTooltip) return fromFitTooltip;
      }
    }

    var variantId = getSelectedVariantId();
    if (variantId) {
      var spans = document.querySelectorAll('[data-variant-id="' + variantId + '"]');
      for (var i = 0; i < spans.length; i++) {
        var fromVariantLens = formatFrameWidthMm(spans[i].getAttribute('data-lens'));
        if (fromVariantLens) return fromVariantLens;
      }
    }

    return '';
  }

  function extractFrameColorFromDescription(rawDesc) {
    if (!rawDesc) return '';
    var match = rawDesc.match(/(?:^|[,\s])Color:\s*([^,\n]+)/i);
    return match ? normalizeText(match[1]) : '';
  }

  function getFrameColorFromPdp() {
    var colorValueEl = document.querySelector('.ciw-pdp__frame-color-value[data-selected-value]');
    if (colorValueEl) {
      var fromLegend = normalizeText(colorValueEl.textContent);
      if (fromLegend) return fromLegend;
    }

    var checkedColor = document.querySelector(
      '.ciw-pdp__variant-fieldset--frame-color input[type="radio"]:checked'
    );
    if (!checkedColor) return '';

    var colorLabel =
      checkedColor.closest('label') ||
      document.querySelector('label[for="' + checkedColor.id + '"]');
    if (colorLabel) {
      var swatchValue = colorLabel.querySelector('.ciw-pdp__frame-color-value');
      if (swatchValue) return normalizeText(swatchValue.textContent);
    }

    return normalizeText(checkedColor.value);
  }

  function extractColorFromVariantPart(variantPart) {
    if (!variantPart) return '';
    var segments = variantPart.split(/\s*\/\s*/);
    var i;
    for (i = 0; i < segments.length; i++) {
      var segment = normalizeText(segments[i]);
      if (segment && !isFrameSizeLikeText(segment)) return segment;
    }
    return '';
  }

  function buildFrameDetailsLine(productName, color, frameWidth) {
    var parts = [];
    if (productName) parts.push(productName);
    if (color) parts.push(color);
    if (frameWidth) parts.push(frameWidth);
    return parts.join(', ');
  }

  function parseFrameSection(item) {
    if (!item) return null;

    var strong = item.querySelector('.la-label-title strong');
    var descEl = item.querySelector('.la-label-description');
    var priceScope = item.querySelector('.la-review-right') || item;
    var priceEl =
      item.querySelector('.la-review-right .la-label-title') ||
      priceScope.querySelector('.la-label-title');
    var name = normalizeText(strong);
    var rawDesc = normalizeText(descEl);

    var productName = name;
    var variantPart = '';
    if (name.indexOf(' - ') > -1) {
      var nameParts = name.split(' - ');
      productName = normalizeText(nameParts[0]);
      variantPart = normalizeText(nameParts.slice(1).join(' - '));
    }

    var color = extractFrameColorFromDescription(rawDesc);
    if (!color) color = extractColorFromVariantPart(variantPart);
    if (!color) color = getFrameColorFromPdp();

    var frameWidth = getFrameWidthMmFromDom();
    if (!frameWidth) frameWidth = extractMmFromSizeText(variantPart);
    if (!frameWidth) {
      var sizeMatch = rawDesc.match(/Size:\s*([^,\n]+)/i);
      if (sizeMatch) frameWidth = extractMmFromSizeText(sizeMatch[1]);
    }
    if (!frameWidth) frameWidth = extractMmFromSizeText(rawDesc);

    var details = buildFrameDetailsLine(productName, color, frameWidth);

    return {
      key: 'frame',
      title: 'Frame',
      price: extractPriceText(priceEl || priceScope),
      comparePrice: extractComparePriceText(priceEl || priceScope),
      details: [details].filter(Boolean)
    };
  }

  function formatLensPackageLabel(name) {
    var label = normalizeText(name);
    if (!label) return '';
    if (/lens package/i.test(label)) return label;
    return label + ' lens package';
  }

  function isTransitionsLensFlow(la, item) {
    if (la && la.response) {
      var lens = la.response.lens;
      if (lens) {
        var groupTitle = normalizeText(lens.group_title || '');
        var groupType = normalizeText(lens.group_type || '');
        if (/transition|photochromic|xtr\s*active|xtractive/i.test(groupTitle) || /transition|photochromic|xtr\s*active|xtractive/i.test(groupType)) return true;
      }

      if (la.lensGroups && la.response.lensGroupSelected) {
        var selectedKey = la.response.lensGroupSelected;
        var i;
        for (i = 0; i < la.lensGroups.length; i++) {
          var group = la.lensGroups[i];
          if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) continue;
          var title = normalizeText(group.group_title || group.title || '');
          if (/transition|photochromic|xtr\s*active|xtractive/i.test(title)) return true;
        }
      }
    }

    if (item) {
      var itemText = normalizeText(item.textContent || '');
      if (/lens group:\s*[^,]*(?:transition|photochromic|xtr\s*active|xtractive)/i.test(itemText)) return true;
    }

    return false;
  }

  function isBlueLightLensFlow(la, item) {
    if (la && la.response) {
      var lens = la.response.lens;
      if (lens) {
        var groupTitle = normalizeText(lens.group_title || '');
        var groupType = normalizeText(lens.group_type || '');
        if (/blue\s*light/i.test(groupTitle) || /blue\s*light/i.test(groupType)) return true;
      }

      if (la.lensGroups && la.response.lensGroupSelected) {
        var selectedKey = la.response.lensGroupSelected;
        var i;
        for (i = 0; i < la.lensGroups.length; i++) {
          var group = la.lensGroups[i];
          if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) continue;
          var title = normalizeText(group.group_title || group.title || '');
          if (/blue\s*light/i.test(title)) return true;
        }
      }
    }

    if (item) {
      var itemText = normalizeText(item.textContent || '');
      if (/lens group:\s*[^,]*blue\s*light/i.test(itemText)) return true;
    }

    return false;
  }

  function getLensAdvizorCustomOptionValue(la, keyPattern) {
    if (!la) return '';

    var sources = [la.customOptions || {}, la.customFieldData || {}];
    var i;
    var j;
    var source;
    var keys;
    var key;

    for (i = 0; i < sources.length; i++) {
      source = sources[i];
      keys = Object.keys(source);
      for (j = 0; j < keys.length; j++) {
        key = keys[j];
        if (keyPattern.test(key)) return normalizeText(source[key]);
      }
    }

    return '';
  }

  function getTransitionsTypeLineFromLensAdvizor() {
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.lens) return '';

    var fromCustom = getLensAdvizorCustomOptionValue(la, /choose\s*your\s*lenses/i);
    var fromName = normalizeText(la.response.lens.name);

    if (fromCustom && (!fromName || isLikelyThicknessTierName(fromName))) return fromCustom;
    if (fromName && !isLikelyThicknessTierName(fromName)) return fromName;
    return fromCustom || fromName;
  }

  function parseReviewPropertyValue(item, propertyPattern) {
    if (!item) return '';

    var value = '';
    item.querySelectorAll('.la-review-left > .la-label-description').forEach(function (block) {
      if (block.classList.contains('la-lens-option-text')) return;
      if (/prescription type|method|selfie/i.test(block.textContent || '')) return;

      var text = htmlToPlainText(block.innerHTML);
      var match = text.match(propertyPattern);
      if (match) value = normalizeText(match[1]);
    });

    return value;
  }

  function stripReviewPropertyLabel(text) {
    return normalizeText(String(text || '')).replace(
      /^(?:choose\s*your\s*lenses|lens\s*thickness|transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|^color)\s*:\s*/i,
      ''
    );
  }

  function isLensColorOptionName(name) {
    var normalized = normalizeText(name).toLowerCase();
    if (!normalized) return false;
    if (/frame\s*color|lens\s*group|lens\s*thickness|lens\s*material|^material$/i.test(normalized)) {
      return false;
    }
    if (
      /transition\s*color|^color$|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|photochromic\s*tint|tint\s*color/i.test(
        normalized
      )
    ) {
      return true;
    }
    return /\bcolor\b/i.test(normalized);
  }

  function isTransitionColorOptionName(name) {
    return isLensColorOptionName(name);
  }

  function isLensColorDomLine(raw) {
    return /(?:transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|(?:^|,\s*)color\s*:)/i.test(
      String(raw || '')
    );
  }

  function parseLensColorFromDomText(raw) {
    var text = normalizeText(raw);
    if (!text) return '';

    var patterns = [
      /transition\s*color\s*:\s*(.+)/i,
      /lens\s*color\s*:\s*(.+)/i,
      /photochromic\s*color\s*:\s*(.+)/i,
      /xtr\s*active\s*color\s*:\s*(.+)/i,
      /xtractive\s*color\s*:\s*(.+)/i,
      /(?:^|,\s*)color\s*:\s*([^,]+)/i
    ];
    var i;
    var match;

    for (i = 0; i < patterns.length; i++) {
      match = text.match(patterns[i]);
      if (match) return normalizeText(match[1]);
    }

    return '';
  }

  function getLensAdvizorColorCustomOptionValue(la) {
    if (!la) return '';

    var patterns = [
      /transition\s*color/i,
      /lens\s*color/i,
      /^color$/i,
      /photochromic\s*color/i,
      /xtr\s*active\s*color/i,
      /xtractive\s*color/i,
      /\bcolor\b/i
    ];
    var i;
    var value;

    for (i = 0; i < patterns.length; i++) {
      value = getLensAdvizorCustomOptionValue(la, patterns[i]);
      if (value) return stripReviewPropertyLabel(value);
    }

    return '';
  }

  function isLensThicknessOptionName(name) {
    return /lens\s*thickness|lens\s*material|^material$/i.test(normalizeText(name));
  }

  function isLikelyThicknessTierName(name) {
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(normalizeText(name));
  }

  function extractThicknessTierKeyword(raw) {
    var text = normalizeText(raw);
    if (!text) return '';

    var part = text.split(' - ')[0].trim().toLowerCase();
    var full = text.toLowerCase();

    if (part === 'basic' || full === 'basic') return 'Basic';
    if (part === 'standard' || full === 'standard') return 'Standard';
    if (part.indexOf('polycarbonate') !== -1 || full.indexOf('polycarbonate') !== -1) {
      return 'Polycarbonate';
    }
    if (part.indexOf('supreme') !== -1 || full.indexOf('supreme') !== -1) return 'Supreme+';
    if (part.indexOf('premium') !== -1 || full.indexOf('premium') !== -1) return 'Premium';

    return text.split(' - ')[0].trim();
  }

  function normalizeThicknessTierName(raw) {
    if (!raw) return '';
    var stripped = stripReviewPropertyLabel(raw);
    var keyword = extractThicknessTierKeyword(stripped);
    return keyword || stripped;
  }

  function lensNameMatchesTierKeyword(lensName, tierKeyword) {
    var name = normalizeText(lensName).toLowerCase();
    var keyword = normalizeText(tierKeyword).toLowerCase();
    if (!name || !keyword) return false;
    if (name === keyword) return true;

    var namePart = name.split(' - ')[0].trim();
    var keywordPart = keyword.split(' - ')[0].trim();
    if (namePart === keywordPart) return true;
    if (namePart === keyword || keywordPart === name) return true;
    if (name.indexOf(keyword) !== -1 || keyword.indexOf(namePart) !== -1) return true;

    return false;
  }

  function isExcludedThicknessLookupGroup(groupOrKey) {
    var text = normalizeText(
      groupOrKey && groupOrKey.group_title
        ? groupOrKey.group_title || groupOrKey.title || groupOrKey.group_type
        : groupOrKey
    ).toLowerCase();
    if (!text) return false;
    return /sunglass|polarized|non-polarized|non polarized/.test(text);
  }

  function isThicknessTierLens(la, lens, typeLensName) {
    if (!lens) return false;

    var name = normalizeText(lens.name);
    if (!name) return false;
    if (isLikelyThicknessTierName(name)) return true;

    var typeName = normalizeText(typeLensName);
    if (typeName && lensNameMatchesTierKeyword(name, typeName)) return false;
    if (/transition/i.test(name)) return false;

    var description = htmlToPlainText(lens.description || '');
    return description.length > 20;
  }

  function isTransitionsLensGroup(group) {
    if (!group) return false;
    var title = normalizeText(group.group_title || group.title || '');
    var type = normalizeText(group.group_type || '');
    return /transition|photochromic|xtr\s*active|xtractive/i.test(title) || /transition|photochromic|xtr\s*active|xtractive/i.test(type);
  }

  function getTransitionsLensGroupKeys(la) {
    var keys = [];
    if (!la) return keys;

    function addKey(key) {
      key = key == null ? '' : String(key);
      if (key && keys.indexOf(key) === -1) keys.push(key);
    }

    if (la.lensGroups) {
      var gi;
      for (gi = 0; gi < la.lensGroups.length; gi++) {
        if (isTransitionsLensGroup(la.lensGroups[gi])) {
          addKey(la.lensGroups[gi].group_type);
          addKey(la.lensGroups[gi].id);
        }
      }
    }

    if (la.response && la.response.lens) {
      var responseLens = la.response.lens;
      addKey(responseLens.group_type);
      addKey(responseLens.group_id);
      addKey(responseLens.lens_group_id);

      if (la.lensesByGroups && responseLens.id != null) {
        var typeLensId = String(responseLens.id);
        var bucketKeys = Object.keys(la.lensesByGroups);
        var bk;
        for (bk = 0; bk < bucketKeys.length; bk++) {
          var bucketLenses = la.lensesByGroups[bucketKeys[bk]] || [];
          var bl;
          for (bl = 0; bl < bucketLenses.length; bl++) {
            if (String(bucketLenses[bl].id) === typeLensId) {
              addKey(bucketKeys[bk]);
              break;
            }
          }
        }
      }
    }

    if (la.response && la.response.lensGroupSelected) {
      addKey(la.response.lensGroupSelected);
    }

    return keys;
  }

  function getThicknessLookupGroupKeys(la) {
    var keys = getTransitionsLensGroupKeys(la);
    if (!la || !la.lensesByGroups) return keys;

    var bucketKeys = Object.keys(la.lensesByGroups);
    var i;
    for (i = 0; i < bucketKeys.length; i++) {
      if (isExcludedThicknessLookupGroup(bucketKeys[i])) continue;
      if (keys.indexOf(bucketKeys[i]) === -1) keys.push(bucketKeys[i]);
    }

    return keys;
  }

  function lensBelongsToGroupKeys(la, lens, groupKeys) {
    if (!lens || !groupKeys.length) return false;

    var lensGroupKey = String(lens.group_type || lens.group_id || lens.lens_group_id || '');
    if (lensGroupKey && groupKeys.indexOf(lensGroupKey) !== -1) return true;

    if (!la.lensesByGroups) return false;

    var lensId = String(lens.id || '');
    if (!lensId) return false;

    var g;
    var j;
    for (g = 0; g < groupKeys.length; g++) {
      var groupLenses = la.lensesByGroups[groupKeys[g]] || [];
      for (j = 0; j < groupLenses.length; j++) {
        if (String(groupLenses[j].id) === lensId) return true;
      }
    }

    return false;
  }

  function findLensInGroupKeysByName(la, tierName, groupKeys) {
    if (!la || !tierName || !groupKeys.length) return null;

    var g;
    var j;

    if (la.lensesByGroups) {
      for (g = 0; g < groupKeys.length; g++) {
        if (isExcludedThicknessLookupGroup(groupKeys[g])) continue;
        var groupLenses = la.lensesByGroups[groupKeys[g]] || [];
        for (j = 0; j < groupLenses.length; j++) {
          if (lensNameMatchesTierKeyword(groupLenses[j].name, tierName)) return groupLenses[j];
        }
      }
    }

    if (la.lenses) {
      for (j = 0; j < la.lenses.length; j++) {
        var lens = la.lenses[j];
        if (!lensBelongsToGroupKeys(la, lens, groupKeys)) continue;
        if (isExcludedThicknessLookupGroup(lens.group_type || lens.group_title)) continue;
        if (lensNameMatchesTierKeyword(lens.name, tierName)) return lens;
      }
    }

    return null;
  }

  function findLensInGroupKeysById(la, lensId, groupKeys) {
    if (!la || lensId == null || !groupKeys.length) return null;

    var targetId = String(lensId);
    var g;
    var j;

    if (la.lensesByGroups) {
      for (g = 0; g < groupKeys.length; g++) {
        if (isExcludedThicknessLookupGroup(groupKeys[g])) continue;
        var groupLenses = la.lensesByGroups[groupKeys[g]] || [];
        for (j = 0; j < groupLenses.length; j++) {
          if (String(groupLenses[j].id) === targetId) return groupLenses[j];
        }
      }
    }

    if (la.lenses) {
      for (j = 0; j < la.lenses.length; j++) {
        var lens = la.lenses[j];
        if (String(lens.id) !== targetId) continue;
        if (isExcludedThicknessLookupGroup(lens.group_type || lens.group_title)) continue;
        if (lensBelongsToGroupKeys(la, lens, groupKeys)) return lens;
      }
    }

    return null;
  }

  function findTransitionsThicknessLens(la, tierName) {
    if (!la || !tierName) return null;

    var preferredKeys = getTransitionsLensGroupKeys(la);
    var lookupKeys = getThicknessLookupGroupKeys(la);
    var typeLensName =
      la.response && la.response.lens ? normalizeText(la.response.lens.name) : '';
    var tierKeyword = normalizeThicknessTierName(tierName);
    var g;
    var j;

    function tryKeys(groupKeys) {
      if (!groupKeys.length) return null;

      if (la.response && la.response.lens) {
        var responseLens = la.response.lens;
        if (
          lensNameMatchesTierKeyword(responseLens.name, tierKeyword) &&
          isThicknessTierLens(la, responseLens, typeLensName) &&
          lensBelongsToGroupKeys(la, responseLens, groupKeys)
        ) {
          return responseLens;
        }
      }

      if (la.response && la.response.lensVariant) {
        var lensVariant = la.response.lensVariant;
        var variantLensIds = [
          lensVariant.lens_id,
          lensVariant.lensId,
          lensVariant.product_id,
          lensVariant.id
        ];
        var vi;
        for (vi = 0; vi < variantLensIds.length; vi++) {
          if (variantLensIds[vi] == null) continue;
          var variantLens = findLensInGroupKeysById(la, variantLensIds[vi], groupKeys);
          if (
            variantLens &&
            isThicknessTierLens(la, variantLens, typeLensName) &&
            lensNameMatchesTierKeyword(variantLens.name, tierKeyword)
          ) {
            return variantLens;
          }
        }
      }

      var byName = findLensInGroupKeysByName(la, tierKeyword, groupKeys);
      if (byName && isThicknessTierLens(la, byName, typeLensName)) return byName;

      if (la.lensesByGroups) {
        for (g = 0; g < groupKeys.length; g++) {
          if (isExcludedThicknessLookupGroup(groupKeys[g])) continue;
          var groupLenses = la.lensesByGroups[groupKeys[g]] || [];
          for (j = 0; j < groupLenses.length; j++) {
            var candidate = groupLenses[j];
            if (!isThicknessTierLens(la, candidate, typeLensName)) continue;
            if (lensNameMatchesTierKeyword(candidate.name, tierKeyword)) return candidate;
          }
        }
      }

      return null;
    }

    var fromPreferred = tryKeys(preferredKeys);
    if (fromPreferred) return fromPreferred;

    return tryKeys(lookupKeys);
  }

  function getLensDescriptionFromLensObject(lens) {
    if (!lens) return '';
    if (lens.description) return htmlToPlainText(lens.description);
    if (lens.lens_type) return htmlToPlainText(lens.lens_type);
    return '';
  }

  function getLensTierDescriptionFromLensAdvizor(la, tierName) {
    if (!la || !tierName) return '';

    var lens = findTransitionsThicknessLens(la, tierName);
    return getLensDescriptionFromLensObject(lens);
  }

  function getTransitionsThicknessTierNameFromLensAdvizor(la) {
    if (!la || !la.response) return '';

    var fromCustom = getLensAdvizorCustomOptionValue(la, /thickness|lens\s*material/i);
    if (fromCustom) return normalizeThicknessTierName(fromCustom);

    if (la.response.lensVariant) {
      var typeName = normalizeText(la.response.lens && la.response.lens.name);
      var variantName = normalizeText(la.response.lensVariant.name);
      if (
        variantName &&
        variantName !== 'Default Title' &&
        variantName !== typeName &&
        !/transition/i.test(variantName)
      ) {
        var fromVariant = normalizeThicknessTierName(variantName);
        if (fromVariant && fromVariant !== typeName) return fromVariant;
      }
    }

    if (la.response.lens && la.response.lensVariant) {
      var lens = la.response.lens;
      var lensVariant = la.response.lensVariant;
      var tierName = '';

      Object.keys(lens.options || {}).forEach(function (key) {
        if (tierName) return;
        var option = lens.options[key];
        var selected = lensVariant[key];
        if (!option || !selected || selected === 'Default Title') return;
        if (isTransitionColorOptionName(option.name || key)) return;
        if (isLensThicknessOptionName(option.name || key)) {
          tierName = normalizeThicknessTierName(selected);
        }
      });

      if (tierName) return tierName;
    }

    if (la.response.lens && isLikelyThicknessTierName(la.response.lens.name)) {
      return normalizeThicknessTierName(la.response.lens.name);
    }

    return '';
  }

  function getTransitionsThicknessTierNameFromDom(item) {
    if (!item) return '';

    var fromProperty = parseReviewPropertyValue(item, /lens\s*thickness\s*:\s*([^,]+)/i);
    if (fromProperty) return normalizeThicknessTierName(fromProperty);

    var fromOptionText = '';
    item.querySelectorAll('.la-review-left > .la-label-description.la-lens-option-text').forEach(function (node) {
      if (fromOptionText) return;
      var raw = htmlToPlainText(node.innerHTML);
      var match = raw.match(/(?:lens\s*thickness|lens\s*material)\s*:\s*(.+)/i);
      if (match) fromOptionText = normalizeThicknessTierName(match[1]);
    });

    return fromOptionText;
  }

  function getThicknessDescriptionFromDomOptionBlocks(item) {
    if (!item) return '';

    var parts = [];
    item.querySelectorAll('.la-review-left > .la-label-description.la-lens-option-text').forEach(function (node) {
      var raw = htmlToPlainText(node.innerHTML);
      if (!raw || isLensColorDomLine(raw)) return;

      var thicknessMatch = raw.match(/(?:lens\s*thickness|lens\s*material)\s*:\s*(.+)/i);
      if (thicknessMatch) {
        var value = normalizeText(thicknessMatch[1]);
        if (value && !isLikelyThicknessTierName(value) && value.length > 15) {
          parts.push(value);
        }
        return;
      }

      if (!/choose\s*your\s*lenses/i.test(raw) && raw.length > 15 && !/transition/i.test(raw)) {
        parts.push(raw);
      }
    });

    return parts.join(', ');
  }

  function debugTransitionsThickness(source, detail) {
    if (!window.ciwLaReviewDebug) return;
    console.debug('[ciw-la-review] transitions thickness:', source, detail || '');
  }

  function getTransitionsThicknessDescriptionFromLensAdvizor(la) {
    if (!la || !la.response) return '';

    var tierName = getTransitionsThicknessTierNameFromLensAdvizor(la);
    debugTransitionsThickness('tierName', tierName);

    if (tierName) {
      var description = getLensTierDescriptionFromLensAdvizor(la, tierName);
      if (
        description &&
        normalizeText(description).toLowerCase() !== normalizeText(tierName).toLowerCase() &&
        !isLikelyThicknessTierName(description)
      ) {
        debugTransitionsThickness('lens lookup', description);
        return description;
      }
    }

    if (la.response.lensVariant) {
      var fromVariant = getLensDescriptionFromLensObject(la.response.lensVariant);
      if (
        fromVariant &&
        !isLikelyThicknessTierName(fromVariant) &&
        normalizeText(fromVariant).toLowerCase() !==
          normalizeText(la.response.lens && la.response.lens.name).toLowerCase()
      ) {
        debugTransitionsThickness('lensVariant fallback', fromVariant);
        return fromVariant;
      }
    }

    return '';
  }

  function getTransitionsThicknessDescriptionFromDom(item, la) {
    if (!item) return '';

    var fromBlocks = getThicknessDescriptionFromDomOptionBlocks(item);
    if (fromBlocks) {
      debugTransitionsThickness('dom option blocks', fromBlocks);
      return fromBlocks;
    }

    var tierName = getTransitionsThicknessTierNameFromDom(item);
    if (!tierName) return '';

    if (la) {
      var description = getLensTierDescriptionFromLensAdvizor(la, tierName);
      if (
        description &&
        normalizeText(description).toLowerCase() !== normalizeText(tierName).toLowerCase() &&
        !isLikelyThicknessTierName(description)
      ) {
        debugTransitionsThickness('dom tier lookup', description);
        return description;
      }
    }

    return '';
  }

  function parseLensOptionDisplayValue(text) {
    var normalized = stripReviewPropertyLabel(text);
    if (!normalized || isLensColorDomLine(normalized)) return '';

    var match = normalized.match(/^([^:]+):\s*(.+)$/);
    if (!match) return normalized;

    var label = normalizeText(match[1]);
    var value = normalizeText(match[2]);

    if (isTransitionColorOptionName(label)) return '';
    if (!value || /^(yes|included|free|true)$/i.test(value)) return label;
    if (value.toLowerCase() === label.toLowerCase()) return label;
    return value;
  }

  function getTransitionsColorFromLensAdvizor(la) {
    if (!la) return '';

    var fromCustom = getLensAdvizorColorCustomOptionValue(la);
    if (fromCustom) return fromCustom;

    if (la.additionalInformations) {
      var infoKeys = Object.keys(la.additionalInformations);
      var ik;
      for (ik = 0; ik < infoKeys.length; ik++) {
        if (!isLensColorOptionName(infoKeys[ik])) continue;
        var fromInfo = normalizeText(la.additionalInformations[infoKeys[ik]]);
        if (fromInfo) return fromInfo;
      }
    }

    if (!la.response || !la.response.lens || !la.response.lensVariant) return '';

    var lens = la.response.lens;
    var lensVariant = la.response.lensVariant;
    var colorValue = '';

    Object.keys(lens.options || {}).forEach(function (key) {
      if (colorValue) return;
      var option = lens.options[key];
      var selected = lensVariant[key];
      if (!option || !selected || selected === 'Default Title') return;
      if (!isLensColorOptionName(option.name || key)) return;
      colorValue = normalizeText(selected);
    });

    return colorValue;
  }

  function getTransitionsColorFromDom(item) {
    if (!item) return '';

    var propertyPatterns = [
      /transition\s*color\s*:\s*([^,]+)/i,
      /lens\s*color\s*:\s*([^,]+)/i,
      /photochromic\s*color\s*:\s*([^,]+)/i,
      /xtr\s*active\s*color\s*:\s*([^,]+)/i,
      /xtractive\s*color\s*:\s*([^,]+)/i,
      /(?:^|,\s*)color\s*:\s*([^,]+)/i
    ];
    var i;
    var fromProperty = '';

    for (i = 0; i < propertyPatterns.length; i++) {
      fromProperty = parseReviewPropertyValue(item, propertyPatterns[i]);
      if (fromProperty) return fromProperty;
    }

    var fromOptionText = '';
    item.querySelectorAll('.la-review-left > .la-label-description.la-lens-option-text').forEach(function (node) {
      if (fromOptionText) return;
      var parsed = parseLensColorFromDomText(htmlToPlainText(node.innerHTML));
      if (parsed) fromOptionText = parsed;
    });

    return fromOptionText;
  }

  function appendTransitionColorToType(typeName, colorValue) {
    var type = stripReviewPropertyLabel(typeName);
    var color = stripReviewPropertyLabel(colorValue);
    if (!type) return '';
    if (!color) return type;
    if (type.toLowerCase().indexOf(color.toLowerCase()) !== -1) return type;
    return type + ' ' + color;
  }

  function getTransitionsTypeWithColorFromLensAdvizor() {
    var la = window.LensAdvizor;
    var typeName = getTransitionsTypeLineFromLensAdvizor();
    var colorValue = getTransitionsColorFromLensAdvizor(la);
    return appendTransitionColorToType(typeName, colorValue);
  }

  function getTransitionsTypeWithColorFromDom(item) {
    var typeName = getTransitionsTypeLineFromDom(item);
    var colorValue = getTransitionsColorFromDom(item);
    return appendTransitionColorToType(typeName, colorValue);
  }

  function getTransitionsTypeLineFromDom(item) {
    if (!item) return '';

    var strong = item.querySelector('.la-label-title strong');
    var fromTitle = normalizeText(strong);
    if (fromTitle) return fromTitle;

    return parseReviewPropertyValue(item, /choose\s*your\s*lenses\s*:\s*([^,]+)/i);
  }

  function getLensDescriptionFromLensAdvizor() {
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.lens) return '';

    var lens = la.response.lens;
    var description = htmlToPlainText(lens.description || '');

    if (!description && la.response.lensVariant) {
      description = htmlToPlainText(la.response.lensVariant.lens_type || '');
    }

    return description;
  }

  function getLensDescriptionFromDom(item, isTransitions) {
    if (!item) return '';

    var parts = [];

    item.querySelectorAll('.la-review-left > .la-label-description.la-lens-option-text').forEach(function (node) {
      var text = htmlToPlainText(node.innerHTML);
      if (text) parts.push(text);
    });

    item.querySelectorAll('.la-review-left > .la-label-description').forEach(function (block) {
      if (block.classList.contains('la-lens-option-text')) return;
      if (/prescription type/i.test(block.textContent || '')) return;

      var text = htmlToPlainText(block.innerHTML)
        .replace(/Lens Group:\s*[^,]+,?\s*/gi, '')
        .replace(/Frame:\s*[^,]+,?\s*/gi, '');

      if (isTransitions) {
        text = text
          .replace(/choose\s*your\s*lenses\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/lens\s*thickness\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/transition\s*color\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/lens\s*color\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/photochromic\s*color\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/xtr\s*active\s*color\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/xtractive\s*color\s*:\s*[^,]+,?\s*/gi, '')
          .replace(/(?:^|,\s*)color\s*:\s*[^,]+,?\s*/gi, '');
      }

      text = text.replace(/\s+/g, ' ').trim();
      if (text) parts.push(text);
    });

    return parts
      .join(', ')
      .replace(/,\s*,/g, ',')
      .replace(/^,\s*|,\s*$/g, '')
      .trim();
  }

  function buildTransitionsLensLines(la, item) {
    var typeWithColor = getTransitionsTypeWithColorFromLensAdvizor();
    if (!typeWithColor) typeWithColor = getTransitionsTypeWithColorFromDom(item);

    var thicknessDescription = getTransitionsThicknessDescriptionFromLensAdvizor(la);
    if (!thicknessDescription) thicknessDescription = getTransitionsThicknessDescriptionFromDom(item, la);

    var parts = [];
    if (typeWithColor) parts.push(typeWithColor);
    if (
      thicknessDescription &&
      normalizeText(thicknessDescription) !== normalizeText(typeWithColor)
    ) {
      parts.push(thicknessDescription);
    }

    if (!parts.length) return [];
    return [parts.join(', ')];
  }

  function isSunglassesLensTypeName(name) {
    return /^(solid tint|gradient tint|polarized)$/i.test(normalizeText(name));
  }

  function isReadingSunglassesLensFlow(la, item) {
    la = la || window.LensAdvizor;
    if (!la || !la.response || !la.response.lens) return false;

    var lens = la.response.lens;
    var isSunglassesLens =
      isSunglassesLensTypeName(lens.name) || /sunglass/i.test(normalizeText(lens.group_title || ''));

    if (!isSunglassesLens && item) {
      isSunglassesLens = /lens group:\s*sunglass/i.test(normalizeText(item.textContent || ''));
    }

    if (!isSunglassesLens) return false;
    return isInlineSunglassesPrescriptionContext(la, item);
  }

  function getSunglassesColorFromLensAdvizor(la) {
    if (!la || !la.response) return '';
    var lensVariant = la.response.lensVariant || {};
    var rawOptions = la.response.raw_options || {};
    return normalizeText(lensVariant.option1 || rawOptions.option1 || '');
  }

  function getSunglassesPackageTierFromLensAdvizor(la) {
    if (!la || !la.response) return '';
    var lensVariant = la.response.lensVariant || {};
    var rawOptions = la.response.raw_options || {};
    var tier = normalizeText(lensVariant.option2 || rawOptions.option2 || '');
    if (!tier) return '';
    if (isLikelyThicknessTierName(tier)) return normalizeThicknessTierName(tier);
    return tier;
  }

  var INLINE_SUNGLASSES_USAGE_RE =
    /reading|distance|non[\s-]?prescription|fashion|plano|progressive|bifocal/i;

  function isInlineSunglassesPrescriptionContext(la, item) {
    if (la && la.response && la.response.selectedPrescriptionType) {
      var sel = la.response.selectedPrescriptionType;
      var text =
        typeof sel === 'string'
          ? sel
          : [sel.title, sel.name, sel.type, sel.handle].filter(Boolean).join(' ');
      if (INLINE_SUNGLASSES_USAGE_RE.test(text)) return true;
    }

    if (item) {
      var usage = parsePrescriptionUsageFromLensItem(item);
      if (INLINE_SUNGLASSES_USAGE_RE.test(usage.prescriptionType || '')) return true;
      if (/lens group:\s*sunglass/i.test(normalizeText(item.textContent || ''))) return true;
    }

    return false;
  }

  function formatSunglassesTypeWithColor(typeName, colorValue) {
    var type = stripReviewPropertyLabel(typeName);
    var color = stripReviewPropertyLabel(colorValue);
    if (!type) return '';
    if (!color) return type;
    if (type.toLowerCase().indexOf(color.toLowerCase()) !== -1) return type;
    if (/\bcolor\b/i.test(type)) return type + ' ' + color;
    return type + ' color ' + color;
  }

  function getSunglassesTypeNameFromLensAdvizor(la) {
    if (!la || !la.response || !la.response.lens) return '';
    var lens = la.response.lens;
    var typeName = normalizeText(lens.name);
    if (isSunglassesLensTypeName(typeName)) return typeName;

    var groupTitle = normalizeText(lens.group_title || '');
    if (/sunglass/i.test(groupTitle) && typeName && !isLikelyThicknessTierName(typeName)) {
      return typeName;
    }

    return '';
  }

  function getSunglassesTypeNameFromDom(item) {
    if (!item) return '';
    var strong = item.querySelector('.la-label-title strong');
    var fromTitle = normalizeText(strong);
    if (isSunglassesLensTypeName(fromTitle)) return fromTitle;
    return parseReviewPropertyValue(item, /(?:choose\s*your\s*lenses|gradient tint|solid tint|polarized)\s*:\s*([^,]+)/i);
  }

  function getSunglassesColorFromDom(item) {
    if (!item) return '';
    return parseReviewPropertyValue(item, /select\s*color\s*:\s*([^,]+)/i);
  }

  function getSunglassesPackageTierFromDom(item) {
    if (!item) return '';
    var tier = parseReviewPropertyValue(item, /choose\s*lens\s*package\s*:\s*([^,]+)/i);
    if (!tier) return '';
    if (isLikelyThicknessTierName(tier)) return normalizeThicknessTierName(tier);
    return tier;
  }

  function getSunglassesPackageFeatures(la, tierName, item) {
    var features = getPackageFeaturesFromRawOptions(la, tierName);
    if (!features) features = getProgressivePackageTierDescription(la, tierName);
    if (!features) features = getLensDescriptionFromLensObject(findPackageTierLens(la, tierName));
    if (!features && item) features = getLensDescriptionFromDom(item, false);
    return features;
  }

  function buildReadingSunglassesLensLine(la, item) {
    la = la || window.LensAdvizor;
    var typeName = getSunglassesTypeNameFromLensAdvizor(la);
    var color = getSunglassesColorFromLensAdvizor(la);
    var tier = getSunglassesPackageTierFromLensAdvizor(la);

    if (!typeName) typeName = getSunglassesTypeNameFromDom(item);
    if (!color) color = getSunglassesColorFromDom(item);
    if (!tier) tier = getSunglassesPackageTierFromDom(item);

    var parts = [];
    var typeWithColor = formatSunglassesTypeWithColor(typeName, color);
    if (typeWithColor) parts.push(typeWithColor);

    if (tier) {
      var packageLabel = formatLensPackageLabel(tier);
      var features = getSunglassesPackageFeatures(la, tier, item);
      if (features) parts.push(packageLabel + ': ' + features);
      else parts.push(packageLabel);
    }

    return parts.join(', ');
  }

  function getLensPackageLineFromLensAdvizor() {
    var la = window.LensAdvizor;
    if (!la || !la.response || !la.response.lens) return '';

    var lens = la.response.lens;
    var description = getLensDescriptionFromLensAdvizor();

    if (isBlueLightLensFlow(la)) {
      var tierLabel = normalizeText(lens.name);
      if (!tierLabel && !description) return '';
      if (tierLabel && description) return 'Blue light blocking, ' + tierLabel + ' ' + description;
      if (tierLabel) return 'Blue light blocking, ' + tierLabel;
      return 'Blue light blocking, ' + description;
    }

    var packageLabel = formatLensPackageLabel(lens.name);

    if (!packageLabel && !description) return '';
    if (packageLabel && description) return packageLabel + ': ' + description;
    return packageLabel || description;
  }

  function parsePrescriptionUsageFromLensItem(item) {
    if (!item) return { prescriptionType: '', methodLabel: '' };

    var prescriptionType = '';
    var methodLabel = '';
    var descBlocks = item.querySelectorAll('.la-review-left > .la-label-description');

    descBlocks.forEach(function (block) {
      if (block.classList.contains('la-lens-option-text')) return;

      block.querySelectorAll('div, .la-review-method').forEach(function (node) {
        var text = normalizeText(node);
        if (/prescription type/i.test(text)) {
          prescriptionType = text.replace(/prescription type\s*:\s*/i, '');
        } else if (/^method/i.test(text)) {
          methodLabel = formatMethodLabel(text.replace(/method\s*:\s*/i, ''));
        }
      });
    });

    return { prescriptionType: prescriptionType, methodLabel: methodLabel };
  }

  function getLensPackageLineFromDom(item) {
    if (!item) return '';

    var la = window.LensAdvizor;
    var strong = item.querySelector('.la-label-title strong');
    var tierLabel = normalizeText(strong);
    var description = getLensDescriptionFromDom(item, false);

    if (isBlueLightLensFlow(la, item)) {
      if (!tierLabel && !description) return '';
      if (tierLabel && description) return 'Blue light blocking, ' + tierLabel + ' ' + description;
      if (tierLabel) return 'Blue light blocking, ' + tierLabel;
      return 'Blue light blocking, ' + description;
    }

    var packageLabel = formatLensPackageLabel(tierLabel);

    if (packageLabel && description) return packageLabel + ': ' + description;
    return packageLabel || description;
  }

  function collectAllLenses(la) {
    var out = [];
    if (!la) return out;

    if (la.lensesByGroups) {
      Object.keys(la.lensesByGroups).forEach(function (key) {
        (la.lensesByGroups[key] || []).forEach(function (lens) {
          if (lens) out.push(lens);
        });
      });
    }

    if (Array.isArray(la.lenses)) {
      la.lenses.forEach(function (lens) {
        if (lens) out.push(lens);
      });
    } else if (la.lenses && typeof la.lenses === 'object') {
      Object.keys(la.lenses).forEach(function (key) {
        if (la.lenses[key]) out.push(la.lenses[key]);
      });
    }

    return out;
  }

  /* Bifocal (w/ Line) is a LINED bifocal, not a progressive-design flow — but
     LensAdvizor tags its selectedPrescriptionType.name / prescription_type as
     "progressive". Its human title is "Bifocal (w/ Line)", so detect off the
     title/usage text instead of the internal name. */
  function isBifocalLinedFlow(la, item) {
    if (la && la.response && la.response.selectedPrescriptionType) {
      var sel = la.response.selectedPrescriptionType;
      var text =
        typeof sel === 'string'
          ? sel
          : [sel.title, sel.description, sel.handle].filter(Boolean).join(' ');
      if (/bifocal/i.test(text)) return true;
    }

    if (item) {
      var usage = parsePrescriptionUsageFromLensItem(item);
      if (/bifocal/i.test(usage.prescriptionType || '')) return true;
    }

    return false;
  }

  // "Clear, Standard lens package: 1.5 Index Basic Lenses (FT-28), ..." — the
  // lens TYPE (group_title), then the package tier + its feature description.
  function buildBifocalLensLine(la, item) {
    var lens = la && la.response && la.response.lens;

    var lensType = lens ? normalizeText(lens.group_title) : '';
    var tierName = lens ? normalizeThicknessTierName(lens.name) : '';
    var description = getLensDescriptionFromLensObject(lens);

    if (!tierName && item) {
      var strong = item.querySelector('.la-label-title strong');
      tierName = normalizeThicknessTierName(normalizeText(strong));
    }
    if (!description && item) {
      description = getLensDescriptionFromDom(item, false);
    }

    var packageLabel = formatLensPackageLabel(tierName);
    var tail = '';
    if (packageLabel && description) tail = packageLabel + ': ' + description;
    else if (packageLabel) tail = packageLabel;
    else if (description) tail = description;

    var parts = [];
    if (lensType) parts.push(lensType);
    if (tail) parts.push(tail);
    return parts.join(', ');
  }

  function isProgressiveLensFlow(la, item) {
    if (la && la.response && la.response.selectedPrescriptionType) {
      var sel = la.response.selectedPrescriptionType;
      var text =
        typeof sel === 'string'
          ? sel
          : [sel.title, sel.name, sel.type, sel.handle].filter(Boolean).join(' ');
      if (/progressive/i.test(text)) return true;
    }

    if (item) {
      var usage = parsePrescriptionUsageFromLensItem(item);
      if (/progressive/i.test(usage.prescriptionType || '')) return true;
    }

    return false;
  }

  function getProgressiveTypeName(la, item) {
    if (la && la.response && la.response.lens) {
      var name = normalizeText(la.response.lens.name);
      if (name && !isLikelyThicknessTierName(name)) return name;
    }

    if (item) {
      var strong = item.querySelector('.la-label-title strong');
      var fromTitle = normalizeText(strong);
      if (fromTitle && !isLikelyThicknessTierName(fromTitle)) return fromTitle;
    }

    return '';
  }

  function getProgressivePackageTierName(la, item) {
    if (la && la.response && la.response.lens && la.response.lensVariant) {
      var lens = la.response.lens;
      var lensVariant = la.response.lensVariant;
      var tierName = '';

      Object.keys(lens.options || {}).forEach(function (key) {
        if (tierName) return;
        var selected = lensVariant[key];
        if (!selected || selected === 'Default Title') return;
        if (isLikelyThicknessTierName(selected)) {
          tierName = normalizeThicknessTierName(selected);
        }
      });
      if (tierName) return tierName;

      var variantName = normalizeText(lensVariant.name);
      if (variantName && isLikelyThicknessTierName(variantName)) {
        return normalizeThicknessTierName(variantName);
      }
    }

    if (item) {
      var fromProperty = parseReviewPropertyValue(
        item,
        /lens\s*(?:package|thickness|material)\s*:\s*([^,]+)/i
      );
      if (fromProperty && isLikelyThicknessTierName(fromProperty)) {
        return normalizeThicknessTierName(fromProperty);
      }
    }

    return '';
  }

  function findPackageTierLens(la, tierName) {
    if (!la || !tierName) return null;

    var tierKeyword = normalizeThicknessTierName(tierName);
    var typeName =
      la.response && la.response.lens
        ? normalizeText(la.response.lens.name).toLowerCase()
        : '';
    var candidates = collectAllLenses(la);
    var i;

    for (i = 0; i < candidates.length; i++) {
      var lens = candidates[i];
      if (!lens || !lens.name) continue;
      if (typeName && normalizeText(lens.name).toLowerCase() === typeName) continue;
      if (!lensNameMatchesTierKeyword(lens.name, tierKeyword)) continue;
      var desc = getLensDescriptionFromLensObject(lens);
      if (desc && !isLikelyThicknessTierName(desc)) return lens;
    }

    return null;
  }

  // The package tier feature text (e.g. "1.5 Index Basic Lenses, Scratch
  // Resistant, Anti-Reflective Coating") is NOT a description on any lens
  // object. It lives on the selected lens's raw_options values, keyed by the
  // chosen thickness/package name (Basic, Standard, Polycarbonate, ...).
  function getProgressivePackageTierDescription(la, tierName) {
    if (!la || !la.response || !la.response.lens) return '';

    var rawOptions = la.response.lens.raw_options;
    if (!Array.isArray(rawOptions)) return '';

    var candidates = [];
    function addCandidate(value) {
      var normalized = normalizeText(value).toLowerCase();
      if (normalized && candidates.indexOf(normalized) === -1) candidates.push(normalized);
    }

    addCandidate(tierName);
    var variant = la.response.lensVariant;
    if (variant) {
      ['name', 'option1', 'option2', 'option3'].forEach(function (key) {
        if (variant[key]) addCandidate(variant[key]);
      });
    }
    if (!candidates.length) return '';

    for (var i = 0; i < rawOptions.length; i++) {
      var option = rawOptions[i];
      if (!option || !Array.isArray(option.values)) continue;
      for (var j = 0; j < option.values.length; j++) {
        var value = option.values[j];
        if (!value || !value.name || !value.description) continue;
        if (candidates.indexOf(normalizeText(value.name).toLowerCase()) !== -1) {
          return htmlToPlainText(value.description);
        }
      }
    }

    return '';
  }

  function buildProgressiveLensLine(la, item) {
    var typeName = getProgressiveTypeName(la, item);
    var tierName = getProgressivePackageTierName(la, item);

    var typePart = typeName ? typeName + ' progressives' : 'Progressives';
    if (!tierName) return typePart;

    var packageLabel = tierName + ' lens package';
    var tierDesc = getProgressivePackageTierDescription(la, tierName);
    if (!tierDesc) tierDesc = getLensDescriptionFromLensObject(findPackageTierLens(la, tierName));

    if (tierDesc) return typePart + ', ' + packageLabel + ': ' + tierDesc;
    return typePart + ', ' + packageLabel;
  }

  function getVariantSelectedValues(la) {
    var variant = la && la.response && la.response.lensVariant;
    if (!variant) return [];
    var out = [];
    ['option1', 'option2', 'option3'].forEach(function (key) {
      var val = normalizeText(variant[key]);
      if (val && val !== 'Default Title' && out.indexOf(val) === -1) out.push(val);
    });
    return out;
  }

  // In a transitions progressive flow the selected progressive design (Ultimate
  // HD, Varilux, ...) and the package tier (Basic, Standard, ...) are stored as
  // the lens variant's options, each belonging to a named raw_options group.
  function findVariantValueInRawOptionGroup(la, groupNamePattern) {
    var lens = la && la.response && la.response.lens;
    if (!lens || !Array.isArray(lens.raw_options)) return '';
    var selected = getVariantSelectedValues(la).map(function (v) {
      return v.toLowerCase();
    });
    if (!selected.length) return '';
    for (var i = 0; i < lens.raw_options.length; i++) {
      var opt = lens.raw_options[i];
      if (!opt || !opt.name || !groupNamePattern.test(opt.name) || !Array.isArray(opt.values)) continue;
      for (var j = 0; j < opt.values.length; j++) {
        var name = normalizeText(opt.values[j].name);
        if (name && selected.indexOf(name.toLowerCase()) !== -1) return name;
      }
    }
    return '';
  }

  // Pull the package feature text ONLY from the "Choose lens package" raw_option
  // group, so it can never grab the progressive-type description by accident.
  function getPackageFeaturesFromRawOptions(la, tierName) {
    var lens = la && la.response && la.response.lens;
    if (!lens || !Array.isArray(lens.raw_options) || !tierName) return '';
    var target = normalizeText(tierName).toLowerCase();
    for (var i = 0; i < lens.raw_options.length; i++) {
      var opt = lens.raw_options[i];
      if (!opt || !opt.name || !/lens\s*package|thickness|material/i.test(opt.name) || !Array.isArray(opt.values)) continue;
      for (var j = 0; j < opt.values.length; j++) {
        var value = opt.values[j];
        if (value && value.name && normalizeText(value.name).toLowerCase() === target && value.description) {
          return htmlToPlainText(value.description);
        }
      }
    }
    return '';
  }

  function buildTransitionsProgressiveLensLine(la, item) {
    var typeWithColor = getTransitionsTypeWithColorFromLensAdvizor();
    if (!typeWithColor) typeWithColor = getTransitionsTypeWithColorFromDom(item);

    var progressiveType = findVariantValueInRawOptionGroup(la, /progressive\s*type/i);
    var tierName = findVariantValueInRawOptionGroup(la, /lens\s*package|thickness|material/i);

    // Fallback: split the positional variant options ("Ultimate HD / Standard").
    if (!progressiveType || !tierName) {
      var values = getVariantSelectedValues(la);
      if (!progressiveType && values.length) progressiveType = values[0];
      if (!tierName && values.length > 1) tierName = values[values.length - 1];
    }

    var parts = [];
    if (typeWithColor) parts.push(typeWithColor);
    if (progressiveType) parts.push(progressiveType);
    if (tierName) {
      var features = getPackageFeaturesFromRawOptions(la, tierName);
      if (!features) features = getLensDescriptionFromLensObject(findPackageTierLens(la, tierName));
      var pkgLabel = tierName + ' lens package';
      parts.push(features ? pkgLabel + ': ' + features : pkgLabel);
    }

    return parts.length ? parts.join(', ') : '';
  }

  function parseLensSection(item) {
    if (!item) return null;

    var priceEl = item.querySelector('.la-review-right.la-label-title');
    var lines = [];
    var usage = parsePrescriptionUsageFromLensItem(item);

    if (usage.prescriptionType) {
      lines.push(
        usage.methodLabel
          ? usage.prescriptionType + ' (' + usage.methodLabel + ')'
          : usage.prescriptionType
      );
    }

    var la = window.LensAdvizor;
    var isTransitions = isTransitionsLensFlow(la, item);

    if (isTransitions && isProgressiveLensFlow(la, item)) {
      var transitionsProgressiveLine = buildTransitionsProgressiveLensLine(la, item);
      if (transitionsProgressiveLine) lines.push(transitionsProgressiveLine);
    } else if (isTransitions) {
      buildTransitionsLensLines(la, item).forEach(function (line) {
        lines.push(line);
      });
    } else if (isBifocalLinedFlow(la, item)) {
      var bifocalLine = buildBifocalLensLine(la, item);
      if (bifocalLine) lines.push(bifocalLine);
    } else if (isProgressiveLensFlow(la, item)) {
      var progressiveLine = buildProgressiveLensLine(la, item);
      if (progressiveLine) lines.push(progressiveLine);
    } else if (isReadingSunglassesLensFlow(la, item)) {
      var sunglassesLine = buildReadingSunglassesLensLine(la, item);
      if (sunglassesLine) lines.push(sunglassesLine);
    } else {
      var packageLine = getLensPackageLineFromLensAdvizor();
      if (!packageLine) packageLine = getLensPackageLineFromDom(item);
      if (packageLine) lines.push(packageLine);
    }

    return {
      key: 'lens',
      title: 'Lens',
      price: extractPriceText(priceEl),
      details: lines
    };
  }

  function collectUpgradesFromLaResponse() {
    var la = window.LensAdvizor;
    var items = [];
    var total = 0;

    if (!la || !la.response || !la.response.addOns) {
      return { items: items, total: total };
    }

    Object.keys(la.response.addOns).forEach(function (key) {
      var group = la.response.addOns[key];
      if (!Array.isArray(group)) return;

      group.forEach(function (entry) {
        var title = entry.product && entry.product.title;
        if (!title || items.indexOf(title) !== -1) return;
        items.push(title);

        var variant = entry.product.variants && entry.product.variants[0];
        if (variant && variant.price) {
          total += parsePriceNumber(variant.price) || 0;
        }
      });
    });

    return { items: items, total: total };
  }

  function parseUpgradesFromDom(detailsWrapper) {
    var header = null;
    var headers = detailsWrapper.querySelectorAll('.la-review-item .la-label-title strong');

    for (var i = 0; i < headers.length; i++) {
      if (/add\s*ons|upgrades|custom add\s*ons/i.test(normalizeText(headers[i].textContent))) {
        header = headers[i].closest('.la-review-item');
        break;
      }
    }

    var items = [];
    var total = 0;

    if (header) {
      var cursor = header.nextElementSibling;
      while (cursor) {
        if (cursor.classList.contains('la-divider')) break;
        if (cursor.classList.contains('la-review-item')) {
          var desc = cursor.querySelector('.la-label-description');
          var priceEl = cursor.querySelector('.la-review-right.la-label-title');
          var label = normalizeText(desc);
          var price = extractPriceText(priceEl);
          if (label) {
            items.push(label);
            total += parsePriceNumber(price);
          }
        }
        cursor = cursor.nextElementSibling;
      }
    }

    detailsWrapper.querySelectorAll('.ciw-la-prism-review-row .la-label-description').forEach(function (node) {
      var label = normalizeText(node.textContent);
      if (label && items.indexOf(label) === -1) items.push(label);
    });

    if (!items.length) {
      var fromLa = collectUpgradesFromLaResponse();
      fromLa.items.forEach(function (label) {
        if (items.indexOf(label) === -1) items.push(label);
      });
      if (fromLa.total > 0 && total <= 0) total = fromLa.total;
    }

    var la = window.LensAdvizor;
    var addonsPrice = la && la.prices ? parseFloat(la.prices.addons) : NaN;
    if (!isNaN(addonsPrice) && addonsPrice > 0 && total <= 0) {
      total = addonsPrice;
    }

    if (!items.length && total <= 0) return null;

    return {
      key: 'upgrades',
      title: 'Upgrades',
      price: total > 0 ? formatMoneyFromAmount(total) : '$0.00',
      details: items
    };
  }

  function parseReviewSections(detailsWrapper) {
    var items = Array.prototype.filter.call(detailsWrapper.children, function (child) {
      return child.classList && child.classList.contains('la-review-item');
    });

    var frameItem = null;
    var lensItem = null;

    items.forEach(function (item) {
      if (frameItem && lensItem) return;
      if (!item.classList.contains('la-flex-start')) return;

      var strong = item.querySelector('.la-label-title strong');
      var strongText = normalizeText(strong);

      if (/prescription type|lens group|add\s*ons|quantity|custom add\s*ons/i.test(strongText)) {
        return;
      }

      if (!frameItem) {
        frameItem = item;
        return;
      }

      if (!lensItem) {
        lensItem = item;
      }
    });

    var sections = [];
    var frameSection = parseFrameSection(frameItem);
    var lensSection = parseLensSection(lensItem);
    var upgradesSection = parseUpgradesFromDom(detailsWrapper);

    if (frameSection) {
      var laPrices = window.LensAdvizor && window.LensAdvizor.prices;
      var frameSaleAmount = parsePriceNumber(frameSection.price);
      var first30Prices = getFrameFirst30Prices();

      if (!first30Prices) {
        var config = window.ciwLaSubtotalFooter || {};
        var first30Enabled = config.first30 === true || config.first30 === 'true';
        if (first30Enabled) {
          var listAmount = getFirst30ListAmountFromVariantJson();
          if (listAmount > 0) {
            var saleAmount = (listAmount * 7) / 10;
            first30Prices = {
              list: formatMoneyFromAmount(listAmount),
              sale: formatMoneyFromAmount(saleAmount),
              listAmount: listAmount,
              saleAmount: saleAmount
            };
          }
        }
      }

      if (first30Prices) {
        frameSection.price = first30Prices.sale;
        frameSection.comparePrice = first30Prices.list;
        frameSaleAmount = first30Prices.saleAmount;
      } else {
        if ((!frameSection.price || frameSection.price === '$0.00') && laPrices && laPrices.frame) {
          frameSection.price = formatMoneyFromAmount(laPrices.frame);
          frameSaleAmount = laPrices.frame;
        }

        if (!frameSection.comparePrice) {
          frameSection.comparePrice = getFrameCompareFromLensAdvizor(frameSaleAmount);
        }
        if (!frameSection.comparePrice) {
          frameSection.comparePrice = getShopifyVariantComparePrice(frameSaleAmount);
        }
        if (
          frameSection.comparePrice &&
          parsePriceNumber(frameSection.comparePrice) <= parsePriceNumber(frameSection.price)
        ) {
          frameSection.comparePrice = '';
        }
      }

      sections.push(frameSection);
    }

    if (lensSection) {
      var lensPrices = window.LensAdvizor && window.LensAdvizor.prices;
      if ((!lensSection.price || lensSection.price === '$0.00') && lensPrices) {
        var lensAmount = lensPrices.lens != null ? lensPrices.lens : lensPrices.lg;
        if (lensAmount != null) lensSection.price = formatMoneyFromAmount(lensAmount);
      }
      sections.push(lensSection);
    }

    if (upgradesSection) sections.push(upgradesSection);

    return sections;
  }

  function buildDetailsHtml(details) {
    if (!details || !details.length) return '';
    return details
      .map(function (line) {
        return '<p class="ciw-la-review-section__line">' + escapeHtml(line) + '</p>';
      })
      .join('');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPriceHtml(section) {
    var sale = section.price || '$0.00';
    var compare = section.comparePrice || '';

    if (
      section.key === 'frame' &&
      compare &&
      parsePriceNumber(compare) > parsePriceNumber(sale)
    ) {
      return (
        '<span class="ciw-la-review-section__price">' +
        '<span class="ciw-la-review-section__compare">' +
        escapeHtml(compare) +
        '</span>' +
        '<span class="ciw-la-review-section__sale">' +
        escapeHtml(sale) +
        '</span>' +
        '</span>'
      );
    }

    return (
      '<span class="ciw-la-review-section__price">' + escapeHtml(sale) + '</span>'
    );
  }

  function buildSectionHtml(section) {
    return (
      '<section class="ciw-la-review-section" data-ciw-la-review-section="' +
      section.key +
      '">' +
      '<div class="ciw-la-review-section__head">' +
      '<h4 class="ciw-la-review-section__title">' +
      escapeHtml(section.title) +
      '</h4>' +
      buildPriceHtml(section) +
      '</div>' +
      '<div class="ciw-la-review-section__details">' +
      buildDetailsHtml(section.details) +
      '</div>' +
      '</section>'
    );
  }

  function buildSepHtml() {
    return '<hr class="ciw-la-review-sep" aria-hidden="true">';
  }

  function buildReviewCard(sections, imageSrc) {
    var mediaHtml = imageSrc
      ? '<div class="ciw-la-review-card__media"><img class="ciw-la-review-card__image" src="' +
        escapeHtml(imageSrc) +
        '" alt="" loading="lazy"></div>'
      : '';

    var innerParts = [];

    if (imageSrc) {
      innerParts.push(buildSepHtml());
    }

    sections.forEach(function (section, index) {
      if (index > 0) {
        innerParts.push(buildSepHtml());
      }
      innerParts.push(buildSectionHtml(section));
    });

    return (
      '<div class="ciw-la-review-card">' +
      mediaHtml +
      '<div class="ciw-la-review-card__inner">' +
      innerParts.join('') +
      '</div></div>'
    );
  }

  function hideElement(el) {
    if (!el) return;
    el.setAttribute('hidden', 'hidden');
    el.style.setProperty('display', 'none', 'important');
  }

  function findReviewCommentField(detailsWrapper) {
    if (!detailsWrapper) return null;
    return (
      detailsWrapper.querySelector('#la-order-notes') ||
      detailsWrapper.querySelector('.la-order-notes-wrapper textarea[name="notes"]') ||
      detailsWrapper.querySelector('textarea[name="notes"]') ||
      null
    );
  }

  function getStoredCommentValue(detailsWrapper) {
    var la = window.LensAdvizor;
    if (la && la.response && typeof la.response.orderNote === 'string' && la.response.orderNote) {
      return la.response.orderNote;
    }

    var nativeField = findReviewCommentField(detailsWrapper);
    return nativeField ? String(nativeField.value || '') : '';
  }

  function syncCommentToLensAdvizor(value) {
    var la = window.LensAdvizor;
    if (la && la.response) {
      la.response.orderNote = value || '';
    }
  }

  function syncCommentToNativeField(nativeField, value) {
    if (!nativeField) return;

    nativeField.value = value || '';
    nativeField.dispatchEvent(new Event('input', { bubbles: true }));
    nativeField.dispatchEvent(new Event('change', { bubbles: true }));
    nativeField.dispatchEvent(new Event('keyup', { bubbles: true }));
  }

  function updateCommentToggleLabel(toggle, open) {
    if (!toggle) return;

    var plus = toggle.querySelector('.ciw-la-manual-rx-comment__plus');
    var label = toggle.querySelector('.ciw-la-manual-rx-comment__label');
    if (plus) plus.textContent = open ? '\u2212' : '+';
    if (label) label.textContent = open ? 'Hide comment' : 'Add comment';
  }

  function setCommentPanelOpen(section, open) {
    if (!section) return;

    var toggle = section.querySelector('.ciw-la-manual-rx-comment__toggle');
    var panel = section.querySelector('.ciw-la-manual-rx-comment__panel');
    if (!toggle || !panel) return;

    section.classList.toggle('ciw-la-manual-rx-section--comment-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.hidden = false;
    updateCommentToggleLabel(toggle, open);
    panel.hidden = !open;
    panel.classList.toggle('ciw-la-manual-rx-hidden', !open);

    if (open) {
      var textarea = panel.querySelector('.ciw-la-manual-rx-comment__textarea');
      if (textarea) {
        window.requestAnimationFrame(function () {
          textarea.focus();
        });
      }
    }
  }

  function buildCommentSection(detailsWrapper, nativeField) {
    var section = document.createElement('div');
    section.className = 'ciw-la-manual-rx-section ciw-la-manual-rx-section--comment ciw-la-review-comment';

    var syncTarget = nativeField;
    var initialValue = getStoredCommentValue(detailsWrapper);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ciw-la-manual-rx-comment__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    var plus = document.createElement('span');
    plus.className = 'ciw-la-manual-rx-comment__plus';
    plus.textContent = '+';
    var label = document.createElement('span');
    label.className = 'ciw-la-manual-rx-comment__label';
    label.textContent = 'Add comment';
    toggle.appendChild(plus);
    toggle.appendChild(document.createTextNode(' '));
    toggle.appendChild(label);

    var panel = document.createElement('div');
    panel.className = 'ciw-la-manual-rx-comment__panel';
    panel.hidden = true;

    var textarea = document.createElement('textarea');
    textarea.className = 'ciw-la-manual-rx-comment__textarea';
    textarea.setAttribute('rows', '3');
    textarea.setAttribute('aria-label', 'Comment');
    textarea.setAttribute('autocomplete', 'off');
    textarea.setAttribute('maxlength', '500');
    textarea.placeholder = 'Any notes for our team?';

    function syncCommentValue(value) {
      syncCommentToLensAdvizor(value);
      syncCommentToNativeField(syncTarget, value);
    }

    toggle.addEventListener('click', function () {
      var isOpen = section.classList.contains('ciw-la-manual-rx-section--comment-open');
      setCommentPanelOpen(section, !isOpen);
    });

    textarea.addEventListener('input', function () {
      syncCommentValue(textarea.value);
    });

    if (initialValue) {
      textarea.value = initialValue;
      syncCommentValue(initialValue);
      setCommentPanelOpen(section, true);
    }

    panel.appendChild(textarea);
    section.appendChild(toggle);
    section.appendChild(panel);

    return section;
  }

  function hideNativeCommentWrapper(detailsWrapper) {
    if (!detailsWrapper) return;

    detailsWrapper.querySelectorAll('.la-order-notes-wrapper').forEach(function (wrapper) {
      if (!wrapper.closest('.ciw-la-manual-rx-section--comment')) {
        hideElement(wrapper);
      }
    });
  }

  var TRUST_CHECK_SVG =
    '<svg class="ciw-la-review-trust__check" xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none" aria-hidden="true">' +
    '<path fill="#158044" fill-rule="evenodd" clip-rule="evenodd" d="M11.187 1.013a.667.667 0 0 1 .094.938l-6.5 8a.667.667 0 0 1-.996.045L.719 5.346a.667.667 0 1 1 .994-.892l2.403 2.65 5.976-7.352a.667.667 0 0 1 .938-.094z"></path>' +
    '</svg>';

  function buildReviewTrustHtml() {
    return (
      '<div class="ciw-la-review-trust" aria-label="Purchase guarantees">' +
      '<div class="ciw-la-review-trust__item">' +
      '<span class="ciw-la-review-trust__icon" aria-hidden="true">' +
      TRUST_CHECK_SVG +
      '</span>' +
      '<span class="ciw-la-review-trust__text">100% money back guaranteed</span>' +
      '</div>' +
      '<span class="ciw-la-review-trust__sep" aria-hidden="true"></span>' +
      '<div class="ciw-la-review-trust__item">' +
      '<span class="ciw-la-review-trust__icon" aria-hidden="true">' +
      TRUST_CHECK_SVG +
      '</span>' +
      '<span class="ciw-la-review-trust__text">Free shipping &amp; returns</span>' +
      '</div>' +
      '</div>'
    );
  }

  function ensureReviewTrustFactors(step, detailsWrapper) {
    step = step || (detailsWrapper && detailsWrapper.closest('.la-render-review'));
    if (!step || !detailsWrapper) return;
    if (!detailsWrapper.querySelector('.ciw-la-review-card')) return;

    var trust = step.querySelector('.ciw-la-review-trust');
    if (!trust) {
      detailsWrapper.insertAdjacentHTML('afterend', buildReviewTrustHtml());
      trust = step.querySelector('.ciw-la-review-trust');
    }

    if (!trust) return;

    trust.classList.remove('ciw-la-review-native-hidden');
    if (detailsWrapper.nextElementSibling !== trust) {
      detailsWrapper.insertAdjacentElement('afterend', trust);
    }
  }

  function ensureReviewCommentSection(detailsWrapper) {
    if (!detailsWrapper) return;

    var existing = detailsWrapper.querySelector('.ciw-la-review-comment');
    if (existing) return;

    hideNativeCommentWrapper(detailsWrapper);

    var nativeField = findReviewCommentField(detailsWrapper);
    var section = buildCommentSection(detailsWrapper, nativeField);
    var cardInner = detailsWrapper.querySelector('.ciw-la-review-card__inner');

    if (cardInner) {
      if (cardInner.children.length > 0) {
        cardInner.insertAdjacentHTML('beforeend', buildSepHtml());
      }
      cardInner.appendChild(section);
      return;
    }

    var card = detailsWrapper.querySelector('.ciw-la-review-card');
    if (card) {
      card.appendChild(section);
      return;
    }

    detailsWrapper.appendChild(section);
  }

  function hideNativeReviewRows(detailsWrapper) {
    Array.prototype.forEach.call(detailsWrapper.children, function (child) {
      if (!child || !child.classList) return;
      if (child.classList.contains('ciw-la-review-card')) return;
      if (child.classList.contains('ciw-la-review-trust')) return;
      child.classList.add('ciw-la-review-native-hidden');
    });
  }

  function getReviewFingerprint(sections, imageSrc) {
    try {
      return JSON.stringify({
        image: imageSrc || '',
        sections: sections.map(function (section) {
          return {
            key: section.key,
            title: section.title,
            price: section.price,
            comparePrice: section.comparePrice,
            details: section.details
          };
        })
      });
    } catch (error) {
      return '';
    }
  }

  function resetReviewScrollPosition(step) {
    var scroller =
      (step && step.closest && step.closest('.la-prescription-modal-content-body')) ||
      document.querySelector('.la-prescription-modal-content-body');
    if (scroller) scroller.scrollTop = 0;
  }

  var reviewAddonsCleanupDone = false;

  function clearReviewAddonsStateOnce() {
    if (reviewAddonsCleanupDone) return;
    reviewAddonsCleanupDone = true;
    document.body.classList.remove('ciw-la-addons-continue-active');
    resetReviewScrollPosition();
    window.requestAnimationFrame(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-review-step:scroll-sync'));
    });
  }

  function enhanceReviewStep() {
    if (!isEyeglassFlow()) return;
    if (enhancing) return;

    var step = document.querySelector(REVIEW_STEP_SELECTOR);
    if (!step) return;

    setReviewTitle(step);

    var detailsWrapper = step.querySelector('.la-review-details-wrapper');
    if (!detailsWrapper) return;

    enhancing = true;

    try {
      clearReviewAddonsStateOnce();

      var sections = parseReviewSections(detailsWrapper);
      if (!sections.length) return;

      var imageSrc = getFeaturedImageSrc();
      var fingerprint = getReviewFingerprint(sections, imageSrc);
      var card = detailsWrapper.querySelector('.ciw-la-review-card');
      var alreadyEnhanced =
        step.classList.contains('ciw-la-review-step--enhanced') &&
        detailsWrapper.classList.contains('ciw-la-review-details--enhanced');

      if (alreadyEnhanced && card && fingerprint === lastReviewFingerprint) {
        ensureReviewTrustFactors(step, detailsWrapper);
        return;
      }

      hideNativeReviewRows(detailsWrapper);

      var cardHtml = buildReviewCard(sections, imageSrc);
      if (!card) {
        detailsWrapper.insertAdjacentHTML('afterbegin', cardHtml);
      } else if (fingerprint !== lastReviewFingerprint) {
        card.outerHTML = cardHtml;
      }

      lastReviewFingerprint = fingerprint;

      ensureReviewCommentSection(detailsWrapper);
      hideNativeCommentWrapper(detailsWrapper);
      ensureReviewTrustFactors(step, detailsWrapper);

      detailsWrapper.classList.add('ciw-la-review-details--enhanced');
      step.classList.add('ciw-la-review-step--enhanced');
    } finally {
      enhancing = false;
    }
  }

  function scheduleEnhance() {
    if (enhanceTimer) window.clearTimeout(enhanceTimer);
    enhanceTimer = window.setTimeout(function () {
      enhanceTimer = null;
      enhanceReviewStep();
      window.setTimeout(enhanceReviewStep, 250);
    }, 0);
  }

  function scheduleEnhanceFromObserver() {
    if (enhancing) return;
    if (!document.querySelector(REVIEW_STEP_SELECTOR)) return;
    if (observerTimer) window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      observerTimer = null;
      enhanceReviewStep();
    }, 80);
  }

  function bind() {
    if (!document.querySelector('.ciw-pdp')) return;

    document.addEventListener('LensAdvizor:review:rendered', scheduleEnhance);
    document.addEventListener('ciw-la-prism:changed', scheduleEnhance);
    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      lastReviewFingerprint = '';
      reviewAddonsCleanupDone = false;
    });

    if (typeof MQ_MOBILE.addEventListener === 'function') {
      MQ_MOBILE.addEventListener('change', scheduleEnhance);
    } else if (typeof MQ_MOBILE.addListener === 'function') {
      MQ_MOBILE.addListener(scheduleEnhance);
    }

    if (typeof MutationObserver !== 'undefined') {
      var modal = document.getElementById('lensadvizor-prescription-modal');
      if (modal && modal.dataset.ciwReviewStepObs !== '1') {
        modal.dataset.ciwReviewStepObs = '1';
        new MutationObserver(scheduleEnhanceFromObserver).observe(modal, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
